module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-763w.fa36bb5c.jpg";